import { render, staticRenderFns } from "./abroadInfo.vue?vue&type=template&id=0c204ac0"
import script from "./abroadInfo.vue?vue&type=script&lang=js"
export * from "./abroadInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports